import { atom } from "recoil";
export const chatIdAtom = atom({
  key: "chat-id",
  default: null,
});
